<template>
<div class="resume-wizard-component flex flex-col items-center">
    <a class="go-back ml-2 md:ml-0 flex justify-start items-center self-start cursor-pointer" @click="$router.go(-1)">
        <img src="/img/back-arrow.svg" class="mr-2">
        <span>{{ $t('go-back') }}</span>
    </a>
    <h1 class="title">
        {{
            products.length ?
            $t('step-5.title-products') :
            $t('step-5.title-products')
        }}
    </h1>
    <div class="resumen-grid w-full flex flex-col items-center">
      <resume-card
        v-for="(product, index) in products"
        :key="product.id"
        :product="product"
        :option="index + 1"
      ></resume-card>
    </div>
    <portal to="contact-question-banner">
      <div class="resumen-choice flex justify-center items-center" :class="[scrolledToBottom ? '' : 'shadow']">
        <div class="flex flex-col justify-center align-center text-center z-10">
          <h3>{{ $t('talk-engineers') }}</h3>
          <div class="flex justify-center mt-4 lg:mt-6">
            <button @click="showPopup = true" class="btn btn-outline-primary whitespace-no-wrap px-2 mx-2 btn-talk">{{ $t('yes') }}</button>
            <button class="btn btn-primary whitespace-no-wrap px-2 mx-2 btn-talk" @click="$router.replace('/contact')">{{ $t('no') }}</button>
          </div>
        </div>
      </div>
    </portal>
    <popup-email @close-popup="showPopup = false" :class="{ open: showPopup }"></popup-email>
</div>
</template>
<script>
import ResumeCard from "./ResumeCard";
import PopupEmail from "./PopupEmail";
import { mapGetters } from "vuex";
import { GETTERS } from "../../store/wizard/types";
import CardSquare from "./cards/CardSquare.vue";
import CardRectangle from "./cards/CardRectangle.vue";

export default {
  components: {
    ResumeCard,
    PopupEmail,
    CardSquare,
    CardRectangle,
  },
  data() {
    return {
      showPopup: false,
      scrolledToBottom: false,
    };
  },
  computed: {
    ...mapGetters({
      products: GETTERS.GET_PRODUCTS,
    }),
  },
  mounted() {
    this.scroll();
    window.onscroll = () => this.scroll();
    window.onresize = () => this.scroll();
  },
  methods: {
    scroll() {
      let bottomOfWindow =
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop
        ) +
          window.innerHeight ===
        document.body.scrollHeight;
      const scrollbarVisible = document.body.scrollHeight > window.innerHeight;

      if (bottomOfWindow || !scrollbarVisible) {
        this.scrolledToBottom = true;
      } else {
        this.scrolledToBottom = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== "specs") {
      return next({ name: "applications" });
    }
    return next();
  },
};
</script>
<style lang="scss" scoped>
@import '../../../sass/variables';

.shadow{
    box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.15) !important;
}
.go-back {
    margin-bottom: 50px;

    @media (min-width: $xl) {
        margin-bottom: 60px;
    }

    span {
        font-size: 16px;
        color: $dark-grey;
        transition: color .2s ease;
    }

    &:hover {
        text-decoration: none;
        span {
            color: $primary;
        }
    }
}
</style>
